import type { BaseUsecase } from '@usecases/base-usecase';
import type { Team } from '@entities/team';
import { Contact, Constants } from '@salesforce/scv-connector-base';

export interface ShowTeamListRepository {
  getTeams(): Promise<Team[]>;
}

export interface ShowTeamListEventPublisher {
  publish(): Promise<void>;
}

export interface ShowTeamListUsecase extends BaseUsecase<Contact[] | void> {
  run(): Promise<Contact[] | void>;
}

export class ShowTeamList implements ShowTeamListUsecase {
  constructor(
    private repository: ShowTeamListRepository,
    private publisher: ShowTeamListEventPublisher,
  ) {}

  async run(): Promise<Contact[] | void> {
    const teams = await this.repository.getTeams();
    const uniqueTeamIDs = new Set<string>();
    const contacts = (teams ?? [])
      .filter((team) => {
        const isEligible = !!team.ID && !uniqueTeamIDs.has(team.ID);
        if (isEligible) {
          uniqueTeamIDs.add(team.ID);
        }
        return isEligible;
      })
      .map(
        (team) =>
          new Contact({
            id: team.ID,
            type: Constants.CONTACT_TYPE.QUEUE,
            name: team.name,
            // hasAgentAvailability is enabled, so every contact needs an
            // availability value to remain visible under the All/Available filters.
            availability: 'AVAILABLE',
          }),
      );

    await this.publisher.publish();
    return contacts;
  }
}
